module.exports = __webpack_public_path__ + "img/four04.47c53e4a.png";